{
  "instances": {
    "quartz": {
      "actions": "Действия",
      "active_triggers": "Активные Триггеры",
      "associated_triggers": "Связанные Триггеры",
      "associated_with_calendar": "Связано с календарем",
      "basic_information": "Основная Информация",
      "calendar": "Календарь",
      "class": "Класс",
      "configuration": "Конфигурация",
      "cron_expression": "Выражение Cron",
      "custom_trigger": "Пользовательский Триггер",
      "days_of_week": "Дни Недели",
      "description": "Описание",
      "details": "Детали",
      "disabled": "Отключено",
      "durable": "Постоянный",
      "enabled": "Включено",
      "end_time": "Время Окончания",
      "final_fire_time": "Время Последнего Срабатывания",
      "friday": "Пятница",
      "group": "Группа",
      "infinite": "Бесконечный",
      "interval": "Интервал",
      "job_data": "Данные Задания",
      "job_name": "Имя Задания",
      "jobs": "Задания",
      "key": "Ключ",
      "label": "Quartz",
      "last_fire": "Последнее Срабатывание",
      "last_fire_time": "Время Последнего Срабатывания",
      "monday": "Понедельник",
      "name": "Имя",
      "next_fire": "Следующее Срабатывание",
      "next_fire_time": "Время Следующего Срабатывания",
      "no": "Нет",
      "no_data": "Информация о Quartz недоступна",
      "paused_triggers": "Приостановленные Триггеры",
      "preserve_hour_of_day": "Сохранить Час Дня",
      "priority": "Приоритет",
      "recovery": "Восстановление",
      "repeat_count": "Количество Повторений",
      "request_recovery": "Запрос Восстановления",
      "saturday": "Суббота",
      "schedule_configuration": "Конфигурация Расписания",
      "skip_day_if_hour_does_not_exist": "Пропустить День, если Час Не Существует",
      "start_time": "Время Начала",
      "state": "Состояние",
      "sunday": "Воскресенье",
      "system_default": "По Умолчанию Системы",
      "thursday": "Четверг",
      "time_window": "Временное Окно",
      "time_zone": "Часовой Пояс",
      "times_triggered": "Количество Срабатываний",
      "timing_information": "Информация о Времени",
      "total": "всего",
      "trigger_data": "Данные Триггера",
      "trigger_failed": "Ошибка запуска",
      "trigger_failed_message": "Ошибка при запуске задания: {error}",
      "trigger_failed_notification": "Ошибка при запуске задания \"{jobName}\": {error}",
      "trigger_fire_times": "Время Срабатывания",
      "trigger_job_now": "Выполнить Задание Сейчас",
      "trigger_success_message": "Задание \"{jobName}\" успешно запущено",
      "trigger_success_title": "Задание Запущено",
      "triggers": "Триггеры",
      "tuesday": "Вторник",
      "type": "Тип",
      "value": "Значение",
      "wednesday": "Среда",
      "yes": "Да"
    }
  }
}
